// extracted by mini-css-extract-plugin
export default {"projects-page":"Projects_projects-page__FMOuA","fade-in":"Projects_fade-in__lPnXP"};